<template>
  <div>
    <h1 class="section-title" v-if="sub === 1">
      <slot name="prepend"></slot>
      {{ computedTitle }}
      <slot name="append"></slot>
    </h1>
    <h2 class="section-title" v-else-if="sub === 2">
      <slot name="prepend"></slot>
      {{ computedTitle }}
      <slot name="append"></slot>
    </h2>
    <h3 class="section-title" v-else-if="sub === 3">
      <slot name="prepend"></slot>
      {{ computedTitle }}
      <slot name="append"></slot>
    </h3>
    <h4 class="section-title" v-else-if="sub === 4">
      <slot name="prepend"></slot>
      {{ computedTitle }}
      <slot name="append"></slot>
    </h4>
    <h5 class="section-title" v-else-if="sub === 5">
      <slot name="prepend"></slot>
      {{ computedTitle }}
      <slot name="append"></slot>
    </h5>
    <v-divider v-if="divider" class="section-divider"></v-divider>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import i18n from '@/i18n';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  translated: {
    type: Boolean,
    default: true,
  },
  sub: {
    type: Number,
    default: 1,
  },
  divider: {
    type: Boolean,
    default: true,
  },
});

const computedTitle = computed({
  get () {
    return props.translated ? i18n.global.t(props.title) : props.title;
  },
});
</script>

<style scoped>
.section-title {
  margin-bottom: 5px;
}
.section-divider {
  margin-bottom: 15px;
}
</style>
